import type { GoalSnapshotResponse } from "@repo/shared/types";
import { get } from "../_client";

const BASE = "/internal/flow-instances/goals";

export function getGoalPortfolioSnapshot(goalId: string) {
  return get<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/portfolio`);
}

export function getGoalXraySnapshot(goalId: string) {
  return get<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/xray`);
}

export function getGoalAssetAllocationSnapshot(goalId: string) {
  return get<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/asset-allocation`);
}

export function getGoalHistoricalReturnSnapshot(goalId: string) {
  return get<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/historical-return`);
}

export function getGoalForecastSnapshot(goalId: string) {
  return get<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/forecast`);
}

export function getGoalCostSnapshot(goalId: string) {
  return get<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/cost`);
}

export function getGoalExpectedValueSnapshot(goalId: string) {
  return get<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/expected-value`);
}

// QL-315 — the asset-class forecast, goal-scoped and instance-scoped.
export function getGoalAssetClassForecastSnapshot(goalId: string) {
  return get<GoalSnapshotResponse>(`${BASE}/${goalId}/snapshot/asset-class-forecast`);
}

export function getInstanceAssetClassForecastSnapshot(instanceId: string) {
  return get<GoalSnapshotResponse>(
    `/internal/flow-instances/${instanceId}/snapshot/instance-asset-class-forecast`,
  );
}

export function getInstanceCostSnapshot(instanceId: string) {
  return get<GoalSnapshotResponse>(`/internal/flow-instances/${instanceId}/snapshot/instance-cost`);
}

export function getInstanceExpectedValueSnapshot(instanceId: string) {
  return get<GoalSnapshotResponse>(
    `/internal/flow-instances/${instanceId}/snapshot/instance-expected-value`,
  );
}
